"use client"
import BuyTicket from "@/app/(event)/events/[id]/BuyTicket";
import CWFResponsiveDialog from "@/components/ui/CWFResponsiveDialog";

export default function BuyTicketModal({ buyTicket, setBuyTicketOpen, eventId = false, redirectModule = "opentraining" }) {
    return (
        <CWFResponsiveDialog open={buyTicket} onOpenChange={setBuyTicketOpen} trigger={null} title={"Choisissez la formule qui vous convient"}>
            <BuyTicket eventId={eventId} redirectModule={redirectModule} />
        </CWFResponsiveDialog>
    )
}